module.exports = __webpack_public_path__ + "img/17.4692895d.jpg";